import { ArticleResolution, ArticleType } from '@wix/ambassador-cc-kb-server-v1-article-translation/types';

import { HelpCenterArticle, HelpCenterVoteableArticle } from '../types';

export const isArticleResolved = (article: HelpCenterArticle): boolean =>
  article.resolution === ArticleResolution.RESOLVED || article.resolution === ArticleResolution.LAUNCHED;

export const isArticleVotable = (article: HelpCenterArticle): article is HelpCenterVoteableArticle => {
  return (
    (article.type === ArticleType.FEATURE_REQUEST || article.type === ArticleType.KNOWN_ISSUE) &&
    !isArticleResolved(article)
  );
};
